import assert from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import {ebsApi} from 'store/ebsApi';
import type {ExpressionV4, ManifestationV4} from './types';
import {
  mapExpressionBaseDto,
  mapManifestationBaseDto,
  mapToExpressionBaseDto,
  mapToManifestationBaseDto,
} from './mappers';

const expressionApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    saveExpression: build.mutation<
      ExpressionV4,
      ExpressionV4,
      Schemas.ExpressionBaseDto
    >({
      query: expression => ({
        url: `expression/${expression.id}`,
        method: 'PUT',
        body: mapToExpressionBaseDto(expression),
      }),
      transformResponse: mapExpressionBaseDto,
    }),
    createNewExpressionWithManifestation: build.mutation<
      {
        expression: ExpressionV4;
        manifestation: ManifestationV4;
      },
      {
        expression: ExpressionV4;
        manifestation: ManifestationV4;
      },
      Schemas.MoveManifestationBaseDto
    >({
      query: ({expression, manifestation}) => ({
        url: `expression/create`,
        method: 'POST',
        body: {
          expressionBaseDto: mapToExpressionBaseDto(expression),
          manifestationBaseDto: mapToManifestationBaseDto(manifestation),
        } as Schemas.MoveManifestationBaseDto,
      }),
      transformResponse: ({manifestationBaseDto, expressionBaseDto}) => {
        const expDto = assert(
          expressionBaseDto,
          'createNewExpressionWithManifestation: expressionBaseDto is expected',
        );
        manifestationBaseDto.expressionId = expDto.id;
        return {
          expression: mapExpressionBaseDto(expDto),
          manifestation: mapManifestationBaseDto(manifestationBaseDto),
        };
      },
    }),
  }),
});

export const {
  useSaveExpressionMutation,
  useCreateNewExpressionWithManifestationMutation,
} = expressionApi;
